import React from 'react';
import { Button } from '@vtbhome/juicyfront';
import { IconBlockedUser } from '@shared/icon/icon-blocked-user/icon-blocked-user';
import { Typography } from '@shared/ui/typography/typography';
import { ROUTE_LOGIN } from '@shared/config/routes/routes';
import { Wrapper, TextWrapper, MailToLink } from './blocked-user-page.styles';
import { useRedirect } from '@shared/lib/hooks/use-redirect/use-redirect';

export const BlockedUserPage: React.FC = () => {
    const redirect = useRedirect();

    const goToLoginStep = () => {
        redirect({ url: ROUTE_LOGIN, type: 'replace' });
    };

    return (
        <>
            <Wrapper>
                <IconBlockedUser />
                <TextWrapper>
                    <Typography size='h5' color='neutral_90'>
                        <b>Вход в личный кабинет заблокирован</b>
                    </Typography>
                    <Typography size='subtitle1' color='neutral_90' as='p'>
                        Для уточнения информации обратитесь в службу технической поддержки портала{' '}
                        <MailToLink href='mailto:profile_support@nota.tech'>profile_support@nota.tech</MailToLink>
                    </Typography>
                </TextWrapper>
                <Button buttonType='light' size='m' onClick={goToLoginStep}>
                    Перейти к авторизации
                </Button>
            </Wrapper>
        </>
    );
};
